import { SEVICES } from '../../../utils/constants';

const Services = () => {
  return (
    <div id={SEVICES} className='services'>
      <div className='services_container container'>
        <h2 data-aos='fade-up' className='text_center'>
          ADDITIONAL SERVICES
        </h2>
        <div className='services_container_text'>
          <ul>
            <li data-aos='fade-up' data-aos-delay='50'>
              Assistance with booking the tours and tailoring unique experience
            </li>
            <li data-aos='fade-up' data-aos-delay='100'>
              Recommendations for best routes and means of transport to and from
              Split
            </li>
            <li data-aos='fade-up' data-aos-delay='150'>
              Recommendations for the best local restaurants and assistance with
              making a reservation
            </li>
            <li data-aos='fade-up' data-aos-delay='200'>
              Reservation and purchase of ferry tickets and tickets for
              different shows, events and theatre{' '}
            </li>
            <li data-aos='fade-up' data-aos-delay='250'>
              Various front desk services - mail sending, wake up calls
            </li>
            <li data-aos='fade-up' data-aos-delay='300'>
              Useful information about Split and Croatia, suggestions for
              planning your itinerary
            </li>
          </ul>
          <p data-aos='fade-up' data-aos-delay='350'>
            Feel free to contact us for help in planning your perfect vacation
            in Split
          </p>
        </div>
      </div>
    </div>
  );
};

export default Services;
